// Données de navigation pour les planètes
export const planetNavItems = [
  {
    title: 'Soleil',
    image: '/images/planetes/soleil_mini.webp',
    url: '/blog/planetes/soleil'
  },
  {
    title: 'Lune',
    image: '/images/planetes/lune_mini.webp',
    url: '/blog/planetes/lune'
  },
  {
    title: 'Mercure',
    image: '/images/planetes/mercure_mini.webp',
    url: '/blog/planetes/mercure'
  },
  {
    title: 'Vénus',
    image: '/images/planetes/venus_mini.webp',
    url: '/blog/planetes/venus'
  },
  {
    title: 'Mars',
    image: '/images/planetes/mars_mini.webp',
    url: '/blog/planetes/mars'
  },
  {
    title: 'Jupiter',
    image: '/images/planetes/jupiter_mini.webp',
    url: '/blog/planetes/jupiter'
  },
  {
    title: 'Saturne',
    image: '/images/planetes/saturne_mini.webp',
    url: '/blog/planetes/saturne'
  },
  {
    title: 'Uranus',
    image: '/images/planetes/uranus_mini.webp',
    url: '/blog/planetes/uranus'
  },
  {
    title: 'Neptune',
    image: '/images/planetes/neptune_mini.webp',
    url: '/blog/planetes/neptune'
  },
  {
    title: 'Pluton',
    image: '/images/planetes/pluton_mini.webp',
    url: '/blog/planetes/pluton'
  }
]; 